import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';

export default function GoogleAnalytics() {
  const { settings } = useSettings();
  const location = useLocation();
  const trackingId = settings?.ga_tracking_id;

  // Inject GA4 script
  useEffect(() => {
    if (!trackingId) return;

    // Avoid duplicate script injection
    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${trackingId}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    document.head.appendChild(script);

    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${trackingId}');
    `;
    document.head.appendChild(inlineScript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(inlineScript);
    };
  }, [trackingId]);

  // Track page views on route change
  useEffect(() => {
    if (!trackingId || !window.gtag) return;

    window.gtag('config', trackingId, {
      page_path: location.pathname + location.search,
    });
  }, [location, trackingId]);

  return null;
}
